import { z } from "zod";
import { PageBlockEditorModelV2, PageSectionEditorModelV2 } from "../elements";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";

export const DocumentationPageContentItem = z.discriminatedUnion("type", [
  PageBlockEditorModelV2,
  PageSectionEditorModelV2,
]);

export const DocumentationPageContentData = z.object({
  items: z.array(DocumentationPageContentItem),
});

export const DocumentationPageContent = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  documentationPageId: z.string(),
  data: DocumentationPageContentData,
});

export type DocumentationPageContentItem = z.infer<typeof DocumentationPageContentItem>;
export type DocumentationPageContentData = z.infer<typeof DocumentationPageContentData>;
export type DocumentationPageContent = z.infer<typeof DocumentationPageContent>;

export type CreateDocumentationPageContent = DbCreateInputOmit<DocumentationPageContent>;
export type UpdateDocumentationPageContent = OmitStrict<
  DbUpdate<DocumentationPageContent>,
  "designSystemVersionId" | "documentationPageId"
>;
